import React from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import Typography from '@johnlewispartnership/wtr-ingredients/foundations/typography';

import PageTitle from 'content/components/PageTitle';
import SearchBar from '.';
import { useRecipesLocation } from '../../utils/utils';

import styles from './index.scss';

const RecipeSearchBar = () => {
  const [searchParams] = useSearchParams();
  const currentSearchTerm = searchParams.get('searchTerm');
  const count = useSelector(state => state.cmsHybridRecipesPage?.totalTaggedRecipes);
  const { isSearchPage, isRecipesHomePage } = useRecipesLocation();

  const resultsCount = () => (
    <Typography element="h1" styleAs="sectionHeadingLight" textStyle="heading-xl">
      Showing {count} results for{' '}
      <Typography element="span" styleAs="sectionHeading" textStyle="heading-xl">
        {currentSearchTerm}
      </Typography>
    </Typography>
  );

  return (
    <section
      style={{ textAlign: 'center' }}
      className={styles.searchTitle}
      data-test="recipes-search-bar"
    >
      {isSearchPage && currentSearchTerm && resultsCount()}
      {!isRecipesHomePage && !currentSearchTerm && <PageTitle title="Search" />}
      <SearchBar />
    </section>
  );
};

export default RecipeSearchBar;
